import React from 'react';

const STEPS = {
    load: {
        next: 'confirm',
        previous: 'load'
    },
    confirm: {
        next: 'import',
        previous: 'load'
    },
    import: {
        next: 'import',
        previous: 'import'
    }
};

export default class ImportWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 'load',
            imported: false,
            importData: ''
        };
    }

    componentDidUpdate(prevProps) {
        if (this.state.step === 'import' && this.state.imported === false) {
            this.setState({ imported: true });
            this.props.onImport(this.state);
        }
    }

    updateImportData = (e) => {
        this.setState({ importData: e.target.value });
    }

    next = () => {
        if (STEPS[this.state.step]) {
            this.setState({ step: STEPS[this.state.step].next });
        }
    }

    prev = () => {
        if (STEPS[this.state.step]) {
            this.setState({ step: STEPS[this.state.step].previous });
        }
    }

    changeSpreadsheet = (spreadsheet) => {
        this.setState({ spreadsheet });
    }

    getBody = () => {
        switch (this.state.step) {
        case 'load':
            return (
                <div>
                    <div>
                        <span className="importNumber">
                            1
                        </span>
                        <span className="importInstruction">
                            <a href="/coaching_schedule/uploads/kaganScheduleImportTemplate.csv">
                                Click this link to download the Import Template.
                            </a> Open the file in Excel (or similar software) once downloaded.
                        </span>
                    </div>
                    <div>
                        <span className="importNumber">
                            2
                        </span>
                        <span className="importInstruction">
                            Fill downloaded template with the names and email addresses of your teachers.
                        </span>
                    </div>
                    <div>
                        <span className="importNumber">
                            3
                        </span>
                        <span className="importInstructions">
                            Select all of the text in the template file (names, email addresses, and headers).
                        </span>
                    </div>
                    <div>
                        <span className="importNumber">
                            4
                        </span>
                        <span className="importInstructions">
                            Copy what you selected and Paste what was copied in the box below:
                        </span>
                    </div>
                    <div>
                        <textarea
                            onChange={ this.updateImportData }
                            value={ this.state.importData }
                            className="modaltextarea" />
                    </div>
                </div>
            );
            break;

        case 'confirm':
            return (
                <div>
                    <div>
                        <span className="importNumber">
                            5
                        </span>
                        <span className="importInstructions">
                            Make sure the headers are above the correct information:
                        </span>
                    </div>
                    <div className="spreadsheet">
                        <Spreadsheet
                            data={ this.state.importData }
                            onChange={ this.changeSpreadsheet } />
                    </div>
                    <div>
                        <span className="importNumber">
                            6
                        </span>
                        <span className="importInstructions">
                            To import the data, click the Save button below.
                        </span>
                    </div>
                </div>
            );
            break;

        case 'import':
            return (
                <div className="importInstructions">
                    <br />
                    <h3>Importing. Please wait.</h3>
                    <br />
                    <div>
                        <strong>The new schedule items will appear as they are imported.</strong>
                    </div>
                </div>
            );
            break;
        }

        return null;
    }

    getFooter = () => {
        switch (this.state.step) {
        case 'load':
            return (
                <div>
                    <button type="button" className="floaterButton other" onClick={ this.next }>Continue</button>
                </div>
            );
            break;

        case 'confirm':
            return (
                <div>
                    <button type="button" className="floaterButton other" onClick={ this.next }>Save</button>
                    &nbsp;
                    <button type="button" className="floaterButton" onClick={ this.prev }>Go Back</button>
                </div>
            );
            break;

        case 'import':
            return (
                <div>
                    <button type="button" className="floaterButton" onClick={ this.props.onClose }>Close</button>
                </div>
            );
        }

        return null;
    }

    preventClose = (e) => {
        e.stopPropagation();
        return false;
    }

    render() {
        return (
            <div>
                <div id="popupImport" className="purpPopup" onClick={ this.props.onClose }>
                    <div className="modal-dialog" onClick={ this.preventClose }>
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="sit">Import Coaching Schedule</span>
                                <span className="close" onClick={ this.props.onClose }>&#215;</span>
                            </div>
                            <div className="modal-body">
                                { this.getBody() }
                            </div>
                            <div className="modal-footer">
                                { this.getFooter() }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop" onClick={ this.props.onClose }></div>
            </div>
        );
    }
}

class Spreadsheet extends React.Component {
    constructor(props) {
        super(props);

        this.HEADER_OPTIONS = [
            { search: 'unused', value: '', name: 'Not Used' },
            { search: 'first', value: 'first_name', name: 'First Name' },
            { search: 'last', value: 'last_name', name: 'Last Name' },
            { search: 'full', value: 'full_name', name: 'Full Name' },
            { search: 'mail', value: 'email_address', name: 'E-Mail' },
            { search: 'structure', value: 'structure', name: 'Structure' },
            { search: 'time', value: 'coaching_time', name: 'Time' },
            { search: 'date', value: 'coaching_date', name: 'Date' },
            { search: 'room', value: 'room_number', name: 'Room' },
            { search: 'grade', value: 'grade_level', name: 'Grade' },
            { search: 'subject', value: 'subject', name: 'Subject' },
            { search: 'building', value: 'topic', name: 'Building' }
        ];

        this.state = this.generateState(props);

        props.onChange(this.state);
    }

    componentDidUpdate(oldProps, oldState) {
        if (oldState !== this.state) {
            this.props.onChange(this.state);
        }
    }

    generateState = (props) => {
        let data = [];
        let headers = [];

        if (props.data) {
            data = props.data.split(/[\r\n]+/g).map(row => row.split(/\t/g));
            headers = data[0];
            data = data.slice(1);
        }

        let selectedHeaders = this.guessHeaders(headers);

        return {
            data,
            headers,
            selectedHeaders
        };
    }

    guessHeaders = (headers) => {
        return headers.map(header => {
            for (let i = 0; i < this.HEADER_OPTIONS.length; i++) {
                const HEADER_OPTION = this.HEADER_OPTIONS[i];
                if (header.toLowerCase().indexOf(HEADER_OPTION.search) >= 0) {
                    return HEADER_OPTION;
                }
            }

            return this.HEADER_OPTIONS[0];
        });
    }

    setHeader = (index, e) => {
        const selectedHeaders = this.state.selectedHeaders.slice();

        for (let i = 0; i < this.HEADER_OPTIONS.length; i++) {
            if (this.HEADER_OPTIONS[i].value === e.target.value) {
                selectedHeaders[index] = this.HEADER_OPTIONS[i];
                break;
            }
        }

        this.setState({ selectedHeaders });
    }

    render() {
        return (
            <div className="fulltable">
                <div className="importrow importheader">
                    {
                        this.state.selectedHeaders.map((header, index) => (
                            <span key={ index } className="importcell">
                                <select
                                    onChange={ this.setHeader.bind(this, index) }
                                    value={ header.value }>
                                    { this.HEADER_OPTIONS.map(opt => <option key={ opt.value } value={ opt.value }>{ opt.name }</option>) }
                                </select>
                            </span>
                        ))
                    }
                </div>
                {
                    this.state.data.map((datum, index) => (
                        <div key={ index } className="importrow">
                            <span className="importrow">
                                {
                                    datum.map((d, ind) => <span key={ `${d}.${ind}` } className="importcell">{ d }&nbsp;</span>)
                                }
                            </span>
                        </div>
                    ))
                }
            </div>
        );
    }
}
